import cn from 'classnames';
import { useRouter } from 'next/router';
import React from 'react';
import { sameParent } from 'utils/urlUtils';

import s from './Navigation.module.scss';

interface INavLink {
  name: string;
  url: string;
  icon?: string;
  newTab?: boolean;
  transparent: boolean;
  dark: boolean;
  isSticky?: boolean;
  otherUrls?: string[];
  className?: string;
  onAction: (actionName: string, url?: string, newTab?: boolean) => void;
}

const NavLink = ({
  name,
  url,
  newTab,
  transparent,
  dark,
  isSticky,
  otherUrls,
  onAction
}: INavLink) => {
  const router = useRouter();

  const isActive =
    (!newTab && sameParent(router, url)) ||
    (otherUrls && otherUrls?.some((url) => sameParent(router, url)));

  return (
    <button
      key={name}
      onClick={() => onAction && onAction(name, url, newTab)}
      className={cn(s.Navigation__link, s.Navigation__content_item, {
        transparent,
        dark,
        isSticky,
        isActive
      })}
    >
      {name}
    </button>
  );
};

export default NavLink;
